"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const rowStyle = (isChecked) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    width: '100%',
    padding: '14px 16px',
    minHeight: '52px',
    border: '1px solid #e0e0e0',
    borderRadius: '10px',
    background: isChecked ? '#f5f5f5' : 'white',
    cursor: 'pointer',
    textAlign: 'left',
    fontSize: '16px',
    fontFamily: 'inherit',
});
const boxStyle = (isChecked) => ({
    flexShrink: 0,
    width: '26px',
    height: '26px',
    borderRadius: '7px',
    border: isChecked ? '2px solid #10b981' : '2px solid #bbb',
    background: isChecked ? '#10b981' : 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: '16px',
    fontWeight: 700,
});
const labelStyle = (isChecked) => ({
    color: isChecked ? '#999' : '#222',
    textDecoration: isChecked ? 'line-through' : 'none',
    fontWeight: 600,
    lineHeight: 1.35,
});
const QuestionChecklist = ({ items, checked, onToggle }) => {
    return ((0, jsx_runtime_1.jsx)("div", { style: { display: 'flex', flexDirection: 'column', gap: '8px' }, children: items.map((item) => {
            const isChecked = Boolean(checked[item.id]);
            return ((0, jsx_runtime_1.jsxs)("button", { type: "button", onClick: () => onToggle(item.id), style: rowStyle(isChecked), "aria-pressed": isChecked, children: [(0, jsx_runtime_1.jsx)("span", { style: boxStyle(isChecked), children: isChecked ? '✓' : '' }), (0, jsx_runtime_1.jsx)("span", { style: labelStyle(isChecked), children: item.label })] }, item.id));
        }) }));
};
exports.default = QuestionChecklist;
